import styled from "styled-components";

const Wrapper = styled.div`
  font-family: helvetica;
  color: #253569;
  font-size: 1.9em;
  @media (max-width: 640px) {
    font-size: 1.3em;
  }
`;

const Goldfish_Logo = () => {
  return (
    <Wrapper>
      <strong>GoldFish</strong>Creative
    </Wrapper>
  );
};

export default Goldfish_Logo;
